import {
  QueryFunctionContext,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import {EventData} from '../../../components/OrderManager/types/eventData'
import {fetchResponse} from './utils'

// TODO we need to type the eventManager response
export const useEventData = (eventId: number): UseQueryResult<EventData> => {
  return useQuery(
    ['eventManager', eventId],
    async ({queryKey}: QueryFunctionContext): Promise<UseQueryOptions> => {
      return fetchResponse(`/event/${queryKey[1]}/manager`)
    },
  )
}
